/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { dbRealtime, ref, set, get } from '../environments/firebase';
import { useAuth } from '../contexts/AuthContext';
import image1 from "../assets/GG-1.png";
import image2 from "../assets/GG-2.png";
import image3 from "../assets/GG-3PP-3.jpg";
import image4 from "../assets/GG-4.jpg";
import image5 from "../assets/GG5PP-5.jpg";
import image6 from "../assets/GG_6.png";
import { motion, AnimatePresence } from 'framer-motion';

// ─── Theme (matches Pravachan.tsx) ───────────────────────────
const T = {
  bg:       '#F7F5F0',
  surface:  '#FFFFFF',
  surface2: '#F0EDE8',
  border:   '#E5E0D8',
  text:     '#1A1714',
  muted:    '#8A8178',
  accent:   '#C2610A',
  accentBg: '#FEF3E8',
  green:    '#15803D',
  blue:     '#2563EB',
  red:      '#DC2626',
  shadow:   '0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04)',
  shadowMd: '0 4px 12px rgba(0,0,0,0.08)',
};

// ─── Icons ────────────────────────────────────────────────────
const Ic = {
  Back:    () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>,
  Check:   () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>,
  Close:   () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Add:     () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>,
  Save:    () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>,
  Person:  () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  Star:    () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
  Search:  () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  Expand:  () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>,
  Collapse:() => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3"/></svg>,
};

type Mode = 'pick' | 'compose';

// Image Carousel (same style as before, just matches theme)
function SpiritualImageCarousel() {
  const images = [image1, image2, image3, image4, image5, image6];
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx(p => (p + 1) % images.length), 8000);
    return () => clearInterval(t);
  }, []);
  return (
    <div style={{ position: 'relative', width: '100%', height: 280, background: '#0F0E0C', overflow: 'hidden', borderRadius: '16px 16px 0 0' }}>
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(194,97,10,0.08) 0%, transparent 100%)', zIndex: 2, pointerEvents: 'none' }} />
      {images.map((img, i) => (
        <div key={i} style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: i === idx ? 1 : 0, transition: 'opacity 1s ease' }}>
          <img src={img} alt={`Divine ${i + 1}`} style={{ height: '100%', width: '100%', objectFit: 'contain', padding: 16 }} />
        </div>
      ))}
      <div style={{ position: 'absolute', bottom: 40, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: 6, zIndex: 10 }}>
        {images.map((_, i) => (
          <button key={i} onClick={() => setIdx(i)} style={{ height: 4, width: i === idx ? 24 : 6, borderRadius: 2, background: i === idx ? T.accent : 'rgba(255,255,255,0.4)', border: 'none', cursor: 'pointer', transition: 'all 0.3s', padding: 0 }} />
        ))}
      </div>
      <div style={{ position: 'absolute', bottom: 12, left: 0, right: 0, textAlign: 'center', zIndex: 10, pointerEvents: 'none' }}>
        <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, fontStyle: 'italic', margin: 0 }}>"See the divine in every being"</p>
      </div>
    </div>
  );
}

export default function Gungrahan() {
  const { currentUser } = useAuth();
  const [mode, setMode] = useState<Mode>('pick');
  const [name, setName]             = useState('');
  const [nameQuery, setNameQuery]   = useState('');
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [allNames, setAllNames]     = useState<string[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [point, setPoint]           = useState('');
  const [pointsList, setPointsList] = useState<string[]>([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [error, setError]           = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess]       = useState(false);
  const [showMergeDialog, setShowMergeDialog]   = useState(false);
  const [existingPoints, setExistingPoints]     = useState<string[]>([]);

  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const nameInputRef = useRef<HTMLInputElement>(null);
  const suggestionsRef = useRef<HTMLDivElement>(null);

  // Load all existing gun grahan names for autocomplete
  useEffect(() => {
    if (!currentUser) return;
    get(ref(dbRealtime, `users/${currentUser.uid}/gungrahan`)).then(snap => {
      if (snap.exists()) {
        const names = Object.values(snap.val() as Record<string, any>)
        .map((v: any) => v?.name as string)
        .filter((n): n is string => typeof n === 'string' && n.trim().length > 0);
      setAllNames(names);
      }
    }).catch(() => {});
  }, [currentUser]);

  // Filter suggestions as user types
  useEffect(() => {
    if (!nameQuery.trim()) { setSuggestions([]); setShowSuggestions(false); return; }
    const q = nameQuery.toLowerCase();
    const filtered = allNames.filter(n => typeof n === 'string' && n.toLowerCase().includes(q));
    setSuggestions(filtered);
    setShowSuggestions(filtered.length > 0);
  }, [nameQuery, allNames]);

  // Close suggestions on outside click
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (suggestionsRef.current && !suggestionsRef.current.contains(e.target as Node)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selectSuggestion = (n: string) => {
    setName(n);
    setNameQuery(n);
    setShowSuggestions(false);
  };

  const handlePointChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let value = e.target.value;
    if (value.length === 0 || (value[value.length - 1] === '\n' && (value.length === 1 || value[value.length - 2] === '\n'))) {
      value += '• ';
    }
    setPoint(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Backspace') {
      const val = e.currentTarget.value;
      const pos = e.currentTarget.selectionStart;
      if (pos >= 2 && val.substring(pos - 2, pos) === '• ') {
        e.preventDefault();
        const nv = val.substring(0, pos - 2) + val.substring(pos);
        setPoint(nv);
        setTimeout(() => { if (textareaRef.current) { textareaRef.current.selectionStart = pos - 2; textareaRef.current.selectionEnd = pos - 2; } }, 0);
      }
    }
  };

  const addPoint = () => {
    if (!point.trim()) return;
    const cleaned = point.replace(/^•\s+/gm, '').trim();
    setPointsList(p => [...p, cleaned]);
    setPoint('');
    setIsExpanded(false);
  };

  const checkExisting = async () => {
    if (!currentUser) return null;
    const key = name.trim().replace(/[.#$[\]]/g, '');
    const snap = await get(ref(dbRealtime, `users/${currentUser.uid}/gungrahan/${key}`));
    return snap.exists() ? snap.val() : null;
  };

  const handleSave = async () => {
    setError('');
    if (!currentUser) { setError('User not authenticated'); return; }
    if (!name.trim() || pointsList.length === 0) { setError('Please enter a name and at least one point'); return; }
    setSubmitting(true);
    try {
      const existing = await checkExisting();
      if (existing) { setExistingPoints(existing.points || []); setShowMergeDialog(true); setSubmitting(false); return; }
      const key = name.trim().replace(/[.#$[\]]/g, '');
      await set(ref(dbRealtime, `users/${currentUser.uid}/gungrahan/${key}`), { name: name.trim(), points: pointsList, createdAt: Date.now() });
      if (!allNames.includes(name.trim())) setAllNames(p => [...p, name.trim()]);
      resetForm();
      setSuccess(true);
      setTimeout(() => setSuccess(false), 2000);
    } catch (err) {
      setError('Error saving data. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleMerge = async () => {
    if (!currentUser) return;
    const key = name.trim().replace(/[.#$[\]]/g, '');
    const combined = [...existingPoints, ...pointsList];
    await set(ref(dbRealtime, `users/${currentUser.uid}/gungrahan/${key}`), { name: name.trim(), points: combined, createdAt: Date.now() });
    resetForm();
    setShowMergeDialog(false);
    setSuccess(true);
    setTimeout(() => setSuccess(false), 2000);
  };

  const handleCreateNew = async () => {
    if (!currentUser) return;
    let newName = name; let counter = 1; let exists = true;
    while (exists) {
      const check = `${name} (${counter})`;
      const key = check.trim().replace(/[.#$[\]]/g, '');
      const snap = await get(ref(dbRealtime, `users/${currentUser.uid}/gungrahan/${key}`));
      if (!snap.exists()) { newName = check; exists = false; } else counter++;
    }
    const key = newName.trim().replace(/[.#$[\]]/g, '');
    await set(ref(dbRealtime, `users/${currentUser.uid}/gungrahan/${key}`), { name: newName.trim(), points: pointsList, createdAt: Date.now() });
    if (!allNames.includes(newName.trim())) setAllNames(p => [...p, newName.trim()]);
    resetForm();
    setShowMergeDialog(false);
    setSuccess(true);
    setTimeout(() => setSuccess(false), 2000);
  };

  const resetForm = () => { setName(''); setNameQuery(''); setPoint(''); setPointsList([]); setMode('pick'); };

  const inputStyle: React.CSSProperties = {
    width: '100%', boxSizing: 'border-box' as const,
    background: 'transparent', border: 'none', outline: 'none',
    color: T.text, fontFamily: 'inherit', fontSize: 15,
  };

  const canAdd  = point.trim().length > 0;
  const canSave = name.trim().length > 0 && pointsList.length > 0 && !submitting;

  return (
    <div style={{ minHeight: '100vh', background: T.bg, fontFamily: "-apple-system,'Helvetica Neue',sans-serif", color: T.text, maxWidth: 480, margin: '0 auto' }}>

      {/* Success overlay */}
      <AnimatePresence>
        {success && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(247,245,240,0.96)', backdropFilter: 'blur(8px)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16 }}>
            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: 'spring', stiffness: 300, damping: 20 }}
              style={{ width: 72, height: 72, borderRadius: '50%', background: T.green, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
              <Ic.Check />
            </motion.div>
            <p style={{ fontSize: 18, fontWeight: 700, color: T.text }}>Gun Grahan saved!</p>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Merge Dialog */}
      <AnimatePresence>
        {showMergeDialog && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            style={{ position: 'fixed', inset: 0, zIndex: 9000, background: 'rgba(26,23,20,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
            <motion.div initial={{ scale: 0.95, y: 8 }} animate={{ scale: 1, y: 0 }}
              style={{ background: T.surface, borderRadius: 20, padding: 28, maxWidth: 400, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
              <h3 style={{ margin: '0 0 12px', fontSize: 18, fontWeight: 700, color: T.text }}>Name Already Exists</h3>
              <p style={{ margin: '0 0 24px', color: T.muted, fontSize: 15, lineHeight: 1.6 }}>
                You already have an entry for <strong style={{ color: T.accent }}>{name}</strong> with {existingPoints.length} points. What would you like to do?
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <button onClick={handleMerge} style={{ background: T.accent, color: '#fff', border: 'none', borderRadius: 12, padding: '13px', fontSize: 15, fontWeight: 700, cursor: 'pointer', boxShadow: '0 2px 8px rgba(194,97,10,0.3)' }}>
                  Merge with Existing
                </button>
                <button onClick={handleCreateNew} style={{ background: T.green, color: '#fff', border: 'none', borderRadius: 12, padding: '13px', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
                  Create New Entry
                </button>
                <button onClick={() => setShowMergeDialog(false)} style={{ background: T.surface2, color: T.muted, border: `1px solid ${T.border}`, borderRadius: 12, padding: '13px', fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
                  Cancel
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ── STEP 1: Banner + Pick ── */}
      <AnimatePresence mode="wait">
        {mode === 'pick' && (
          <motion.div key="pick" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -16 }}>
            {/* Banner */}
            <div style={{ margin: '0 16px 20px', marginTop: 16 }}>
              <div style={{ background: T.surface, borderRadius: 16, overflow: 'hidden', boxShadow: T.shadowMd, border: `1px solid ${T.border}` }}>
                <SpiritualImageCarousel />
                <div style={{ padding: '20px 24px', borderTop: `1px solid ${T.border}` }}>
                  <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 22, fontWeight: 700, color: T.text, margin: '0 0 6px' }}>✨ Gun Grahan ✨</h1>
                  <p style={{ color: T.muted, margin: 0, fontSize: 14 }}>Write positive points about someone in your life</p>
                </div>
              </div>
            </div>

            {/* Info banner */}
            <div style={{ margin: '0 16px 20px', background: T.accentBg, border: `1px solid rgba(194,97,10,0.25)`, borderRadius: 12, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
              <Ic.Star />
              <p style={{ margin: 0, fontSize: 13, color: T.accent, fontWeight: 600 }}>Start by choosing someone to write a gun grahan for.</p>
            </div>

            <div style={{ padding: '0 16px 32px' }}>
              <button
                onClick={() => setMode('compose')}
                style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 16, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 16, padding: '18px 20px', cursor: 'pointer', textAlign: 'left', boxShadow: T.shadow }}
              >
                <div style={{ width: 48, height: 48, borderRadius: 14, background: 'linear-gradient(135deg,#1D9E75,#0F6E56)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', flexShrink: 0 }}>
                  <Ic.Person />
                </div>
                <div>
                  <p style={{ margin: 0, fontSize: 15, fontWeight: 600, color: T.text }}>Write Gun Grahan</p>
                  <p style={{ margin: '3px 0 0', fontSize: 13, color: T.muted }}>Record positive virtues about someone</p>
                </div>
              </button>
            </div>
          </motion.div>
        )}

        {/* ── STEP 2: Compose ── */}
        {mode === 'compose' && (
          <motion.div key="compose" initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -30 }}
            style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

            {/* Top bar */}
            <div style={{ position: 'sticky', top: 0, zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', background: 'rgba(247,245,240,0.95)', backdropFilter: 'blur(12px)', borderBottom: `1px solid ${T.border}` }}>
              <button onClick={() => setMode('pick')} style={{ background: 'none', border: 'none', color: T.muted, cursor: 'pointer', padding: 4 }}><Ic.Back /></button>
              <span style={{ fontSize: 15, fontWeight: 700, color: T.text, fontFamily: 'Georgia, serif' }}>Gun Grahan</span>
              <button onClick={handleSave} disabled={!canSave}
                style={{ background: canSave ? T.accent : T.border, color: canSave ? '#fff' : T.muted, border: 'none', borderRadius: 20, padding: '7px 18px', fontSize: 14, fontWeight: 700, cursor: canSave ? 'pointer' : 'not-allowed', transition: 'all 0.15s', boxShadow: canSave ? '0 2px 8px rgba(194,97,10,0.3)' : 'none' }}>
                {submitting ? '…' : 'Save'}
              </button>
            </div>

            <div style={{ padding: '16px 16px 0' }}>
              {error && (
                <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 10, padding: '10px 14px', marginBottom: 12, color: T.red, fontSize: 13 }}>
                  {error}
                </div>
              )}

              {/* Name field with autocomplete */}
              <div style={{ background: T.surface, borderRadius: 14, border: `1px solid ${T.border}`, marginBottom: 12, boxShadow: T.shadow, position: 'relative' }}>
                <div style={{ display: 'flex', alignItems: 'center', padding: '11px 14px' }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: T.muted, width: 60, flexShrink: 0 }}>Person</span>
                  <div style={{ flex: 1, position: 'relative' }} ref={suggestionsRef}>
                    <input
                      ref={nameInputRef}
                      style={{ ...inputStyle }}
                      placeholder="e.g. Harshit Patel…"
                      value={nameQuery}
                      onChange={e => { setNameQuery(e.target.value); setName(e.target.value); }}
                      onFocus={() => { if (suggestions.length > 0) setShowSuggestions(true); }}
                      autoComplete="off"
                    />
                    {/* Autocomplete dropdown */}
                    <AnimatePresence>
                      {showSuggestions && (
                        <motion.div
                          initial={{ opacity: 0, y: -4 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -4 }}
                          transition={{ duration: 0.15 }}
                          style={{
                            position: 'absolute', top: 'calc(100% + 8px)', left: -74, right: -14,
                            background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12,
                            boxShadow: T.shadowMd, zIndex: 100, overflow: 'hidden',
                          }}
                        >
                          <div style={{ padding: '6px 0' }}>
                            <p style={{ margin: 0, padding: '6px 14px', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: T.muted }}>
                              Existing entries
                            </p>
                            {suggestions.map((s, i) => {
                              const q = nameQuery.toLowerCase();
                              const idx = s.toLowerCase().indexOf(q);
                              return (
                                <button key={i}
                                  onMouseDown={() => selectSuggestion(s)}
                                  style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '10px 14px', border: 'none', background: 'none', cursor: 'pointer', textAlign: 'left', transition: 'background 0.1s' }}
                                  onMouseEnter={e => { e.currentTarget.style.background = T.surface2; }}
                                  onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
                                >
                                  <div style={{ width: 32, height: 32, borderRadius: '50%', background: T.accentBg, color: T.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, flexShrink: 0 }}>
                                    {s.charAt(0).toUpperCase()}
                                  </div>
                                  <span style={{ fontSize: 14, color: T.text }}>
                                    {idx >= 0 ? (
                                      <>
                                        {s.substring(0, idx)}
                                        <strong style={{ color: T.accent }}>{s.substring(idx, idx + nameQuery.length)}</strong>
                                        {s.substring(idx + nameQuery.length)}
                                      </>
                                    ) : s}
                                  </span>
                                  <span style={{ marginLeft: 'auto', fontSize: 11, color: T.muted }}>add more</span>
                                </button>
                              );
                            })}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                </div>
              </div>

              {/* Points entry */}
              <div style={{ background: T.surface, borderRadius: 14, border: `1px solid ${T.border}`, marginBottom: 12, boxShadow: T.shadow, overflow: 'hidden' }}>
                {/* Textarea toolbar */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 14px', borderBottom: `1px solid ${T.border}`, background: T.surface2 }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: T.muted, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Positive Point</span>
                  <button onClick={() => setIsExpanded(e => !e)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: T.muted, padding: 4 }}>
                    {isExpanded ? <Ic.Collapse /> : <Ic.Expand />}
                  </button>
                </div>
                <textarea
                  ref={textareaRef}
                  value={point}
                  onChange={handlePointChange}
                  onKeyDown={handleKeyDown}
                  placeholder="He always attends mangla aarti…"
                  style={{
                    width: '100%', boxSizing: 'border-box', background: 'transparent', border: 'none', outline: 'none',
                    color: T.text, fontFamily: 'inherit', fontSize: 15, lineHeight: 1.65,
                    padding: '14px 16px', resize: 'none',
                    height: isExpanded ? 240 : 120, transition: 'height 0.2s',
                  }}
                />
              </div>

              {/* Add button */}
              <button onClick={addPoint} disabled={!canAdd}
                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, background: canAdd ? T.blue : T.border, color: canAdd ? '#fff' : T.muted, border: 'none', borderRadius: 12, padding: '13px', fontSize: 15, fontWeight: 700, cursor: canAdd ? 'pointer' : 'not-allowed', marginBottom: 16, transition: 'all 0.15s', boxShadow: canAdd ? '0 2px 8px rgba(37,99,235,0.25)' : 'none' }}>
                <Ic.Add /> Add Point
              </button>

              {/* Points list */}
              {pointsList.length > 0 && (
                <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
                  <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: T.muted, marginBottom: 10 }}>Points added</p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 8 }}>
                    {pointsList.map((p, i) => (
                      <motion.div key={i} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.04 }}
                        style={{ display: 'flex', alignItems: 'flex-start', gap: 10, background: T.accentBg, border: `1px solid rgba(194,97,10,0.2)`, borderRadius: 10, padding: '10px 12px' }}>
                        <span style={{ color: T.accent, fontWeight: 700, fontSize: 13, flexShrink: 0, marginTop: 1 }}>{i + 1}.</span>
                        <span style={{ flex: 1, fontSize: 14, color: T.text, lineHeight: 1.6 }}>{p}</span>
                        <button onClick={() => setPointsList(pl => pl.filter((_, j) => j !== i))} style={{ background: 'none', border: 'none', cursor: 'pointer', color: T.muted, padding: 2, flexShrink: 0 }}>
                          <Ic.Close />
                        </button>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        input::placeholder, textarea::placeholder { color: ${T.muted}; }
        * { box-sizing: border-box; }
        @media (max-width: 480px) { div[style*="maxWidth: 480"] { max-width: 100% !important; } }
      `}</style>
    </div>
  );
}